
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learning-center/[category]/[...article]",
      function () {
        return require("private-next-pages/learning-center/[category]/[...article].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/learning-center/[category]/[...article]"])
      });
    }
  